import { NavLink } from 'react-router-dom'

import { useFamily } from 'context/hooks/useFamily'
import { Popover, Tooltip } from 'antd'
import useQuery from 'context/hooks/useQuery'

import IntegraSocialAnimated from 'components/Icons/IntegraSocialAnimated'

import { useAuthentication } from 'context/AuthContext'

import bigDataSocialLogo from '../../assets/logos/big-data-social.svg'

import logoutIcon from '../../assets/icons/logout-icon.svg'
import { contentButton } from 'utils/contentButtons'
import { useAccessibility } from 'context/hooks/useAccessibility'
import { getOverlayCustomTooltip, hasImage } from 'utils/utils'
import { ReactComponent as ArrowIcon } from 'assets/icons/rightArrow.svg'

import './styles.scss'
import { useCallback } from 'react'

interface AsideMenuProps {
  menuIsExpanded: boolean
  toggleMenu: () => void
}

function AsideMenu({ menuIsExpanded, toggleMenu }: AsideMenuProps) {
  const { infosKinship, numberAlertsPerSections } = useFamily()

  const { basesQuery } = useQuery()

  const { authData, handleLogout } = useAuthentication()

  const { contrastIsSelected } = useAccessibility()

  const bigDataSocialHref =
    process.env.REACT_APP_BIGDATA_URL !== undefined &&
    authData.token !== undefined
      ? `${process.env.REACT_APP_BIGDATA_URL}?token=${authData.token}}`
      : ''

  const logoutButton = useCallback(() => {
    return (
      <button
        className="logout"
        onClick={() => {
          handleLogout()
        }}
      >
        <img src={logoutIcon} alt="Ícone de logout" />
        <span>SAIR</span>
      </button>
    )
  }, [])

  return (
    <aside
      className={`containerAsideMenu ${!menuIsExpanded ? 'menuMinimized' : ''}`}
    >
      <a className="containerAsideMenu-logo" href="/integrasocial/pesquisa">
        <IntegraSocialAnimated isMinimized={!menuIsExpanded} />
      </a>
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div className="containerAsideMenu-hamburger">
          <button
            className={menuIsExpanded ? 'expanded' : ''}
            onClick={() => {
              toggleMenu()
            }}
          >
            <ArrowIcon fill="#fff" color="#fff" />
          </button>
        </div>
      </div>

      <ul className="containerAsideMenu-buttons">
        {contentButton(numberAlertsPerSections).map((component, index) => {
          const withAlert =
            Boolean(component?.alert) && (component?.alert ?? 0) > 0
          return !menuIsExpanded ? (
            <Tooltip
              key={component.title}
              placement="right"
              title={component.title}
              overlayStyle={getOverlayCustomTooltip(contrastIsSelected)}
            >
              <li
                key={component.title}
                className="containerAsideMenu-buttons__button"
              >
                <NavLink
                  to={`${process.env.PUBLIC_URL}/pesquisa/${
                    component.param
                  }?cpf=${infosKinship?.cpf ?? ''}&nis=${
                    infosKinship?.nis ?? ''
                  }&bases=${JSON.stringify(basesQuery)}&area=${
                    component.title
                  }`}
                >
                  <div>
                    <div className="containerAsideMenu-buttons__button--icon">
                      {component.icon}
                      {!menuIsExpanded && withAlert && (
                        <div
                          className="alertTop"
                          style={
                            (component?.alert ?? 0) >= 10
                              ? {
                                  width: '23px',
                                  height: '23px',
                                  top: '-12px',
                                  right: '-16px',
                                }
                              : {}
                          }
                        >
                          <p>{component.alert}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </NavLink>
              </li>
            </Tooltip>
          ) : (
            <li
              key={component.title}
              className="containerAsideMenu-buttons__button"
            >
              <NavLink
                to={`${process.env.PUBLIC_URL}/pesquisa/${
                  component.param
                }?cpf=${infosKinship?.cpf ?? ''}&nis=${
                  infosKinship?.nis ?? ''
                }&bases=${JSON.stringify(basesQuery)}`}
              >
                <div>
                  <div className="containerAsideMenu-buttons__button--icon">
                    {component.icon}
                  </div>
                  <span className="containerAsideMenu-buttons__button--title">
                    {component.title}
                  </span>
                </div>
                {withAlert && (
                  <div className="alertRight">{component.alert}</div>
                )}
              </NavLink>
            </li>
          )
        })}
      </ul>

      <div className="containerAsideMenu-infos">
        <a className="containerAsideMenu-infos__logo" href={bigDataSocialHref}>
          <img src={bigDataSocialLogo} alt="Logo do Big Data Social" />
          {menuIsExpanded && <span>BIG DATA SOCIAL</span>}
        </a>
        <div className="containerAsideMenu-infos__user">
          <Popover content={logoutButton} trigger="hover">
            <button>
              {hasImage(authData) ? (
                <img src={authData.user.image} alt="Foto do usuário logado" />
              ) : (
                <p> {authData.user.name[0]}</p>
              )}
            </button>
          </Popover>
          {menuIsExpanded && <span>{authData.user.name}</span>}
        </div>
      </div>
    </aside>
  )
}

export default AsideMenu
